import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from './i18n';
import { StoreProvider } from './state/store';
import { App } from './App';
import { LoginGate } from './auth/LoginGate';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Wurzelelement #root fehlt im index.html');

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <StoreProvider>
        <LoginGate>
          <App />
        </LoginGate>
      </StoreProvider>
    </I18nProvider>
  </StrictMode>,
);
